// What the house / front-yard / Podwórko Schowek lists (owner 2026-10-03: "items like this not
// always on the bottom visible, we should have Schowek"). Pure, node --test.
//   [{ type: 'furniture' | 'buda' | 'decoration', item, name, count, waiting }]  (name: the catalog's name_pl, else the id)
// Only what can go in `backendScene`: furniture indoors, a buda where its animal may live, a
// decoration where its own allowed_scenes say. `waiting` = animals bought before their house.
export function houseStorageItems(raw, backendScene, { furniture }) {
  const inv = raw?.inventory;
  if (!inv) return [];
  const cat = raw.catalog ?? {};
  const name = (kind, item) => cat[kind]?.[item]?.name_pl ?? item;
  const items = [];
  if (furniture) {
    for (const [item, count] of Object.entries(inv.unplaced_furniture ?? {})) if (count > 0) items.push({ type: 'furniture', item, name: name('furniture', item), count, waiting: 0 });
  }
  for (const [item, count] of Object.entries(inv.unplaced_budas ?? {})) {
    const forAnimal = cat.budas?.[item]?.for_animal;
    if (!(count > 0) || !(cat.animals?.[forAnimal]?.allowed_scenes ?? []).includes(backendScene)) continue;
    items.push({ type: 'buda', item, name: name('budas', item), count, waiting: inv.unplaced_animals?.[forAnimal] ?? 0, forAnimal });
  }
  for (const [item, count] of Object.entries(inv.unplaced_decorations ?? {})) {
    if (count > 0 && (cat.decorations?.[item]?.allowed_scenes ?? []).includes(backendScene)) items.push({ type: 'decoration', item, name: name('decorations', item), count, waiting: 0 });
  }
  return items;
}
